function SiteInfo (props) {
    return(
        <a href="#" onClick={() => props.setState(0)}>
            <div id="siteTitleContainer">
                <h1 id="siteTitle">edsite.black</h1>
            </div>
        </a>
    )
}

export default SiteInfo;